import { useEffect, useMemo, useState } from 'react';

import cn from 'classnames';
import FeatherIcon from 'feather-icons-react';

import styles from './StarRating.module.scss';

export const StarRating = ({ options, value, brand = {}, onChange, disabled }) => {
  const { use_custom_stars, stars, label_start, label_end } = options ?? {};
  const [starsArray, setStarsArray] = useState([]);

  const handleClick = index => {
    if (disabled) return;
    onChange(index);
  };

  const getStarColor = useMemo(() => {
    return brand?.color_button || '#4E18BB';
  }, [brand]);

  useEffect(() => {
    const starsInt = use_custom_stars ? parseInt(stars) : 5;
    const array = Array(starsInt)
      .fill()
      .map((_, index) => index + 1);
    setStarsArray(array);
  }, [use_custom_stars, stars]);

  return (
    <div className={cn(styles.root, { [styles.rootWithLabel]: label_start || label_end })}>
      <div className={styles.starsWrapper}>
        {starsArray.map(index => (
          <FeatherIcon
            className={cn(styles.star, { [styles.disabled]: disabled })}
            key={index}
            icon="star"
            size={35}
            tabIndex={disabled ? -1 : 0}
            color={index <= value ? getStarColor : '#e5e5e5'}
            fill={index <= value ? `${getStarColor}30` : '#e5e5e5'}
            stroke={index <= value ? getStarColor : '#E1E2EC'}
            strokeWidth="1"
            onClick={() => handleClick(index)}
            onKeyDown={e => {
              if (e.key === ' ') {
                e.preventDefault();
                handleClick(index);
              }
            }}
            role="button"
            aria-pressed={index <= value}
          />
        ))}
      </div>
      <label className={styles.labelStart}>{label_start}</label>
      <label className={styles.labelEnd}>{label_end}</label>
    </div>
  );
};
